import { Box, Flex, Image } from '@chakra-ui/react';
import { useRef } from 'react';
import Header from './Header';
import HeaderContent from './HeaderContent';
import ServicesSection from './ServicesSection';
import PropertiesSlideshow from './PropertiesSlideshow';
import About from './About';
import ContactUs from './ContactUs';
import Footer from './Footer';
import header_shape from './assets/images/header_shape.svg';
import shape1 from './assets/images/shape-1.svg';
import shape2 from './assets/images/shape-2.svg';
import shape3 from './assets/images/shape-3.svg';

const LandingPage = () => {
    const headerRef = useRef(null);
    const headerContentRef = useRef(null);
    const servicesSectionRef = useRef(null);
    const propertiesRef = useRef(null);
    const contactUsRef = useRef(null);
    const aboutRef = useRef(null);

    // Function to scroll to a section
    const scrollToSection = (ref) => {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <Box bg="gray.50">
            {/* Header Background with Shapes */}
            <Box 
                bgRepeat="no-repeat" 
                // bgImage={header_shape} 
                bg={"#0a1425"}
                position="relative" 
                w="100%" 
                minH="100vh"
            >
                {/* Background Decorative Shapes */}
                <Image 
                    src={shape1} 
                    position="absolute" 
                    top="0" 
                    left="0" 
                    boxSize="250px" 
                    opacity={0.5} 
                    display={{ base: 'none', md: 'block' }}
                    // animation="float 6s ease-in-out infinite"
                />
                <Image 
                    src={shape2} 
                    position="absolute" 
                    top="10%" 
                    right="5%" 
                    boxSize="300px" 
                    opacity={0.5}
                    display={{ base: 'none', md: 'block' }}
                    // animation="float 8s ease-in-out infinite"
                />
                <Image 
                    src={shape3} 
                    position="absolute" 
                    bottom="20%" 
                    left="-20" 
                    boxSize="350px" 
                    opacity={0.5}
                    display={{ base: 'none', lg: 'block' }}
                    // animation="float 7s ease-in-out infinite"
                />

                {/* Header Component */}
                <Header
                    onButtonClick={(index) => {
                        if (index === 0) scrollToSection(headerContentRef); // Home
                        if (index === 1) scrollToSection(aboutRef); // About
                        if (index === 2) scrollToSection(servicesSectionRef); // Services
                        if (index === 3) scrollToSection(propertiesRef); // Properties
                        if (index === 4) scrollToSection(contactUsRef); // Contact
                    }}
                />

                {/* Header Content Section */}
                <Box ref={headerContentRef}>
                    <HeaderContent featuresRef={servicesSectionRef} />
                </Box>
            </Box>

            {/* Services Section */}
            <Box ref={servicesSectionRef}>
                <ServicesSection />
            </Box>

            {/* Properties Slideshow Section */}
            <Box ref={propertiesRef}>
                <PropertiesSlideshow />
            </Box>

            {/* About Section */}
            <Box ref={aboutRef}>
                <About />
            </Box>

            {/* Contact Section */}
            <Box ref={contactUsRef}>
                <Flex
                    alignItems="center"
                    flexDirection={{ base: 'column', lg: 'row' }}
                    justify="space-between"
                    mx="auto"
                    maxWidth="1200px"
                    px={4}
                >
                    <Box h="auto" w="100%">
                        <ContactUs />
                    </Box>
                </Flex>
            </Box>

            {/* Footer */}
            <Footer />

            {/* Add Custom Animations in Style Tag */}
            {/* <style>{`
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @keyframes float {
                    0%, 100% {
                        transform: translateY(0px) rotate(0deg);
                    }
                    50% {
                        transform: translateY(-20px) rotate(5deg);
                    }
                }

                @keyframes slideDown {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @keyframes slideIn {
                    from {
                        opacity: 0;
                        transform: translateX(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }
            `}</style> */}
        </Box>
    );
};

export default LandingPage;